import { render, staticRenderFns } from "./ChallengeTranslateButton.vue?vue&type=template&id=286e7fe1&scoped=true&"
import script from "./ChallengeTranslateButton.vue?vue&type=script&lang=js&"
export * from "./ChallengeTranslateButton.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeTranslateButton.vue?vue&type=style&index=0&id=286e7fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286e7fe1",
  null
  
)

export default component.exports